export default __webpack_public_path__ + "assets/images/287431a76ddaee2a46e793c9d1e6501f.svg";